/**
 * @generated SignedSource<<969637e2784621a3db26bfb4d3223e21>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SpacesMenuSection_spaces$data = {
  readonly edges: ReadonlyArray<{
    readonly node: {
      readonly space: {
        readonly __typename: "Space";
        readonly color: {
          readonly light: string;
        };
        readonly icon: {
          readonly name?: string;
        };
        readonly id: string;
        readonly name: string;
        readonly order: number;
      };
    } | null;
  }>;
  readonly " $fragmentType": "SpacesMenuSection_spaces";
};
export type SpacesMenuSection_spaces$key = {
  readonly " $data"?: SpacesMenuSection_spaces$data;
  readonly " $fragmentSpreads": FragmentRefs<"SpacesMenuSection_spaces">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SpacesMenuSection_spaces",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "SpaceMembershipEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "SpaceMembership",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Space",
              "kind": "LinkedField",
              "name": "space",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "order",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": null,
                  "kind": "LinkedField",
                  "name": "icon",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "InlineFragment",
                      "selections": [
                        (v0/*: any*/)
                      ],
                      "type": "NamedIcon",
                      "abstractKey": null
                    }
                  ],
                  "storageKey": null
                },
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Color",
                  "kind": "LinkedField",
                  "name": "color",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "light",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "SpaceMembershipConnection",
  "abstractKey": null
};
})();

(node as any).hash = "b35b42104d3d47e571c70152ea41ea49";

export default node;
